import { alpha } from "@mui/material/styles";

export const SCHEDULE_MINT = "#1f7a4d";
export const SCHEDULE_MINT_DARK = "#123524";
export const scheduleHeaderGradient =
  "linear-gradient(135deg, #123524 0%, #1f7a4d 100%)";
export const scheduleHeaderGradientHover =
  "linear-gradient(135deg, #0f2a1c 0%, #1a6b42 100%)";

/** Single day in horizontal date strip (cart + dialog) */
export const calendarDayChipSx = (selected: boolean) => ({
  margin: "0 5px",
  padding: "8px 6px",
  minWidth: "3.6rem",
  borderRadius: "14px",
  cursor: "pointer",
  textAlign: "center",
  transition: "all 0.2s ease",
  flexShrink: 0,
  border: selected
    ? "2px solid transparent"
    : `1px solid ${alpha("#1f7a4d", 0.18)}`,
  background: selected ? scheduleHeaderGradient : "#ffffff",
  color: selected ? "#fff" : SCHEDULE_MINT_DARK,
  boxShadow: selected
    ? "0 8px 22px rgba(31, 122, 77, 0.28)"
    : "0 2px 10px rgba(15, 23, 17, 0.05)",
  "&:hover": {
    borderColor: alpha("#1f7a4d", 0.45),
    background: selected ? scheduleHeaderGradient : alpha("#1f7a4d", 0.07),
    color: selected ? "#fff" : SCHEDULE_MINT_DARK,
  },
});

/** Date strip on gradient header (appointment dialog) — high contrast vs `scheduleHeaderGradient` */
export const calendarDayChipOnGradientSx = (selected: boolean) => ({
  margin: "0 5px",
  padding: "8px 6px",
  minWidth: "3.6rem",
  borderRadius: "14px",
  cursor: "pointer",
  textAlign: "center",
  transition: "all 0.2s ease",
  flexShrink: 0,
  border: selected
    ? `2px solid ${alpha("#fff", 0.95)}`
    : `1px solid ${alpha("#fff", 0.38)}`,
  background: selected ? "#ffffff" : alpha("#fff", 0.14),
  color: selected ? SCHEDULE_MINT_DARK : "#fff",
  boxShadow: selected
    ? "0 8px 22px rgba(0, 0, 0, 0.18)"
    : "0 2px 10px rgba(0, 0, 0, 0.06)",
  "&:hover": {
    background: selected ? "#ffffff" : alpha("#fff", 0.24),
    borderColor: alpha("#fff", 0.6),
    color: selected ? SCHEDULE_MINT_DARK : "#fff",
  },
});

/** Time slot button */
export const slotChipSx = (selected: boolean) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "48px",
  borderRadius: "12px",
  textAlign: "center",
  position: "relative" as const,
  cursor: "pointer",
  transition: "all 0.2s ease",
  border: selected
    ? "2px solid transparent"
    : `1px solid ${alpha("#1f7a4d", 0.22)}`,
  background: selected ? scheduleHeaderGradient : "#fff",
  color: selected ? "#fff" : SCHEDULE_MINT_DARK,
  fontWeight: selected ? 700 : 600,
  boxShadow: selected
    ? "0 6px 18px rgba(31, 122, 77, 0.22)"
    : "0 2px 8px rgba(15, 23, 17, 0.05)",
  "&:hover": {
    background: selected ? scheduleHeaderGradientHover : alpha("#1f7a4d", 0.08),
    borderColor: alpha("#1f7a4d", 0.45),
    color: selected ? "#fff" : SCHEDULE_MINT_DARK,
  },
});

export const primeTimeBadgeSx = {
  color: "#fff",
  background: alpha("#b45309", 0.95),
  width: "fit-content",
  borderRadius: "6px",
  padding: "2px 6px",
  position: "absolute",
  top: -8,
  right: -4,
  fontSize: "11px",
  fontWeight: 700,
  boxShadow: "0 2px 8px rgba(180, 83, 9, 0.35)",
};
